var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-end my-2"},[_c('div',[_c('VvtFilter',{attrs:{"selected":_vm.selectedFilterId,"prepend-title":""},on:{"select":function($event){return _vm.$emit('set-current-filter', $event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }